export const BoardViewColumnDragHandleCls = 'BoardViewColumnDragHandleCls'
export const TaskColumnDraggingCls = 'TaskColumnDraggingCls'
